// src/app/guards/normalize-slash.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { environment } from '../environments/environment';

export const normalizeSlashGuard: CanActivateFn = (_r, state) => {
    const router = inject(Router);
    const needs = environment.trailingSlash;
    const raw = state.url.split(/[?#]/)[0]; // sin query / hash

    // Calculamos la versión “canónica” según la bandera:
    const canonical = needs
        ? raw === '/'
            ? '/'
            : raw.endsWith('/')
              ? raw
              : raw + '/'
        : raw.length > 1 && raw.endsWith('/')
          ? raw.slice(0, -1)
          : raw;

    // Si ya es canónica, continuamos.
    if (raw === canonical) {
        return true;
    }

    // Mantenemos query y hash, si existían:
    const suffix = state.url.substring(raw.length);
    return router.parseUrl(canonical + suffix);
};
